'use strict';

module.exports = function (ngModule) {
    ngModule.controller('endpointTypeUserController', require('./endpoint_by_type_and_user'));
    ngModule.controller('endpointTypeController', require('./endpoint_by_type'));
    ngModule.controller('endpointUserTypeController', require('./endpoint_by_user_and_type'));
    ngModule.controller('endpointUserController', require('./endpoint_by_user'));
    ngModule.controller('endpointEventsSharepointDrillController', require('./endpoint_events_sharepoint_drill'));
    ngModule.controller('endpointEventsSharepointController', require('./endpoint_events_sharepoint'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/system_events/index.js
 **/